import { createUserManager } from "redux-oidc";
import { Layouts } from "../constants/Constants";
import { Paths } from "../constants/UrlConstants";
import { WebStorageStateStore } from "oidc-client";

export const oidcConfig =
window?.axa?.features?.B2CMolcol === "true" ? window.axa.oidc.mol : 
window.axa && window.axa.brand === Layouts.MOL
    ? window.axa.oidc.mol
    : window.axa.oidc.hol;

export const SignInSignUpPolicy = "B2C_1A_SignUpSignIn_R3";
export const InternalViewPolicy = "B2C_1A_InternalView";
export const ChangePasswordPolicy = "B2C_1A_ChangePassword_R3";
export const ChangeUsernamePolicy = "B2C_1A_ChangeUsername_R3";
export const PasswordResetPolicy = "B2C_1A_PasswordReset_R3";

export function B2CLogoutEndpoint(Policy) {
  return `https://${oidcConfig.aad_instance}/${oidcConfig.tenant}/${Policy}/oauth2/v2.0/logout`;
}

const post_logout_redirect_uri = `${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ""
}${oidcConfig.appPath}${Paths.LogoutCallback}`;

const _userManagerConfig = {
  client_id: oidcConfig.client_id,
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }${oidcConfig.appPath}/AuthCallback`,
  response_type: "token id_token",
  scope: `openid https://${oidcConfig.tenant}/${oidcConfig.apiScope}/user_impersonation`,
  authority: `https://${oidcConfig.aad_instance}/tfp/${oidcConfig.tenant}`,
  silent_redirect_uri: `${window.location.protocol}//${
    window.location.hostname
  }${window.location.port ? `:${window.location.port}` : ""}${
    oidcConfig.appPath
  }/silent_renew.html`,
  silentRequestTimeout: 20000,
  automaticSilentRenew: false,
  filterProtocolClaims: true,
  loadUserInfo: false,
  extraQueryParams: {},
  post_logout_redirect_uri: `${window.location.protocol}//${post_logout_redirect_uri}`,
  metadata: {
    issuer: `https://${oidcConfig.aad_instance}/${oidcConfig.tenant_client_id}/v2.0/`,
    jwks_uri: `https://${oidcConfig.aad_instance}/${oidcConfig.tenant}/discovery/v2.0/keys?p=B2C_1A_SignUpSignIn_R3`,
    end_session_endpoint: `https://${oidcConfig.aad_instance}/${oidcConfig.tenant}/oauth2/v2.0/logout`,
    authorization_endpoint: `https://${oidcConfig.aad_instance}/${oidcConfig.tenant}/oauth2/v2.0/authorize`,
    token_endpoint: `https://${oidcConfig.aad_instance}/${oidcConfig.tenant}/oauth2/v2.0/token`
  }
};

if (window.axa && window.axa.brand === Layouts.MOL) {
  _userManagerConfig.post_logout_redirect_uri = `${window.axa.singleSignOutUrl}/Session/Signout?redirectUri=${post_logout_redirect_uri}`;
}
_userManagerConfig.userStore = new WebStorageStateStore({
  store: window.localStorage
});

export const userManagerConfig = _userManagerConfig;

export const GetSignInSignUpPolicy = () => {
  return SignInSignUpPolicy;
};

export default createUserManager(userManagerConfig);
